import { createSelector } from '@reduxjs/toolkit';

import { type SortType } from '@/packages/api-models/common/json_query';

import { useReduxSelector } from '../../../hooks';

import { mapControlsSelector } from './root';

export const activePinSelector = createSelector(mapControlsSelector, state => state.activePin);

export const activePinIdSelector = createSelector(activePinSelector, activePin => activePin?.id);

export function useActivePinIdSelector(): string | undefined {
  return useReduxSelector(activePinIdSelector);
}

export const activePinListingIdSelector = createSelector(activePinSelector, activePin => activePin?.properties?.id);

export function useActivePinListingIdSelector(): string | undefined {
  return useReduxSelector(activePinListingIdSelector);
}

export const activePinPageSelector = createSelector(mapControlsSelector, state => state.activePinPage);

export function useActivePinPageSelector(): number | undefined {
  return useReduxSelector(activePinPageSelector);
}

export const activePinSortSelector = createSelector(mapControlsSelector, state => state.activePinSort);
export function useActivePinSortSelector(): SortType {
  return useReduxSelector(activePinSortSelector);
}

export const hoveredPinIdSelector = createSelector(mapControlsSelector, state => state.hoveredPinId);
export function useHoveredPinIdSelector(): string | undefined {
  return useReduxSelector(hoveredPinIdSelector);
}
